import { useQuery } from '@tanstack/react-query'

import { verifyMoneytreeConnections } from '@src/api'
import { DefaultApiVerifyMoneytreeConnectionsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchverifyMoneytreeConnections = (
  params: DefaultApiVerifyMoneytreeConnectionsRequest,
  enabled = true
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId && enabled,
    queryFn: () => verifyMoneytreeConnections(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.VERIFY_MONEYTREE_CONNECTIONS,
      params.organizationId,
    ],
    staleTime: 0,
  })
}
